import React from 'react';

import DefaultIndustryTemplate from './default-industry-template';
import SectionHero from '../components/SectionHero';

const FintechAndInsuranceIndustryTemplate = (props) => (
  <DefaultIndustryTemplate {...props}>
    <SectionHero
      title="GraphCMS Delivers"
      description="Forward thinking teams across the world use GraphCMS to deliver better
        digital experiences"
    />
  </DefaultIndustryTemplate>
);

export default FintechAndInsuranceIndustryTemplate;
